<template>
    <div class="home-head-container">
        <div class="left-header-container"></div>
        <div class="middle-head-container">
            <div class="middle-top-container">
                <div class="middle-top-box-container">
                    <div class="logo-container" @click="userToHome">
                        <img class="img-100" alt="博雅美育浸润·五馆合一" src="../../assets/logo/logo.png">
                    </div>
                    <div class="head-slogan-container">
                        <div class="top-slogan-container">博雅美育浸润·五馆合一</div>
                        <div class="bottom-slogan-container">学贯东西 通识博雅 以美育心 以文化人</div>
                    </div>
                </div>
            </div>
            <div class="middle-bottom-container">
                故宫博物院 联合支持&nbsp;&nbsp;&nbsp;敦煌研究院 联合支持&nbsp;&nbsp;&nbsp;湖南省博物馆 联合支持&nbsp;&nbsp;&nbsp;山东省博物馆 联合支持&nbsp;&nbsp;&nbsp;中国研学旅行协会 联合支持
            </div>
        </div>
        <div class="right-head-container" v-if="!isLogin">
            <div class="login-btn" @click="userToLogin">登&nbsp;录</div>
        </div>
        <div class="right-head-container" v-if="isLogin">
            <el-dropdown class="cursor">
                <div class="login-user-container">
                    <div class="login-user-left-container">
                        <div class="login-user-avatar">
                            <img class="login-user-avatar" alt="头像" :src="userInfo.avatar + '?_=' + Date.now()" />
                        </div>
                    </div>
                    <div class="login-user-right-container">
                        <div class="login-user-name-container">{{userInfo?userInfo.trueName:''}}</div>
                        <div v-if="role==='1'||role==='2'" class="login-user-type-container">管理员</div>
                        <!-- <div v-if="role==='3'||role==='4'" class="login-user-type-container">代理商</div> -->
                        <div v-if="role==='3'" class="login-user-type-container">一级代理</div>
                        <div v-if="role==='4'" class="login-user-type-container">二级代理</div>
                        <div v-if="role==='5'" class="login-user-type-container">机构</div>
                        <div v-if="role==='6'" class="login-user-type-container">用户</div>
                    </div>
                </div>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="userCenter">个人中心</el-dropdown-item>
                        <el-dropdown-item v-if="role!=='6'"  @click="adminCenter">管理中心</el-dropdown-item>
                        <el-dropdown-item @click="userLogout">安全退出</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </div>
</template>


<script>
import {timestampToTime} from "@/utils/date";
export default {
    name: "homeHead",
    props: {
    },
    data() {
        return {
            timestampToTime,
            isLogin:this.$storage.get('isLogin'),
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            role: this.$storage.get("role"),
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        userToLogin(){
            this.$router.push("/museum/login")
        },
        userToHome(){
            this.$router.push("/museum/home")
        },
        userLogout(){
            this.$confirm("您正在退出当前登录，是否继续？", "退出系统", {
                confirmButtonText: "退出",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$storage.remove("token")
                this.$storage.remove("userInfo")
                this.$storage.remove("role");
                this.$storage.remove("isLogin");
                this.isLogin = false;
                this.$router.push({ path: "/museum/home" });
            })
        },
        adminCenter(){
            this.$router.push({path: '/overview',});
        },
        userCenter(){
            this.$router.push({path: '/museum/userCenter',});
        },
    }

};
</script>

<style scoped lang="scss">
.home-head-container{
    width: 100%;
    height: 88.5px;
    border-bottom: 1.5px solid #b22222;
    display: flex;
}
.left-header-container {
    width: 200px;
    height: 88px;
}
.middle-head-container {
    width: calc(100% - 400px);
    height: 88px;
    padding: 4px 0 4px 0;
    box-sizing: border-box;
}
.middle-top-container{
    width: 100%;
    height: 60px;
}
.middle-top-box-container{
    width: 314px;
    height: 60px;
    display: flex;
    margin: auto;
    padding: 2px 0 4px 0;
    box-sizing: border-box;
}
.logo-container{
    width: 54px;
    height: 54px;
    display: flex;
    cursor: pointer;
}
.head-slogan-container{
    width: calc(100% - 54px);
    height: 54px;
}
.top-slogan-container{
    width: 100%;
    height: 34px;
    line-height: 34px;
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 3px;
    text-align: center;
}
.bottom-slogan-container{
    width: 100%;
    height: 20px;
    font-size: 13px;
    color: #4b5563;
    text-align: center;
    font-family: sans-serif;
    line-height: 20px;
}
.middle-bottom-container{
    width: 100%;
    height: 20px;
    text-align: center;
    font-size: 12px;
    font-family: sans-serif;
    color: #9ca3af;
    line-height: 20px;
}
.right-head-container {
    width: 200px;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-btn{
    padding: 0 10px 0 10px;
    height: 26px;
    text-align: center;
    color: #b22222;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #b22222;
    line-height: 26px;
    font-size: 14px;
    font-family: sans-serif;
    margin-left: 40px;
}
.login-btn:hover{
    color: #fff;
    background: #b22222;
    border: 1px solid #b22222;
}
.login-user-container{
    width: 125px;
    height: 46px;
    display: flex;
    margin-left: 20px;
    cursor: pointer;
}
.login-user-left-container{
    width: 45px;
    height: 46px;
}
.login-user-avatar{
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-top: 2px;
}
.login-user-right-container{
    width: 80px;
    height: 46px;
    padding: 3px 0 3px 0;
}
.login-user-name-container{
    width: 80px;
    height: 25px;
    line-height: 28px;
    font-size: 15px;
    font-weight: bold;
    font-family: sans-serif;
    color: #377f7f;
    letter-spacing: 2px;
}
.login-user-type-container{
    width: 80px;
    height: 15px;
    font-size: 13px;
    font-family: sans-serif;
    color: #9ca3af;
    line-height: 15px;
    letter-spacing: 2px;
}
@media (max-width: 1280px) {
    .left-header-container { width: 120px; }
    .right-head-container { width: 160px; }
    .middle-head-container { width: calc(100% - 280px); }
    .top-slogan-container { font-size: 16px; letter-spacing: 2px; }
}
@media (max-width: 1024px) {
    .left-header-container { display: none; }
    .right-head-container { width: 140px; }
    .middle-head-container { width: calc(100% - 140px); }
    .middle-top-box-container { margin-left: 20px; }
    .login-user-container { margin-left: 0; }
    .login-btn { margin-left: 0; }
}
</style>